import React, { useState, useContext, useEffect } from 'react';
import { useParams, useNavigate, useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useCartStore } from 'stores';
//context
import { GlobalContext } from 'context/globalContext';
//utils
import { getSubTotalOrder, getTotalOrder, getIvaOrder } from 'utils/orderFunctions';
//api
import { getDetailOrderProfile, editDetailOrder } from 'api/orders';
//components
import OrderForm from 'components/backoffice/forms/orderForm';
import Title from 'components/backoffice/texts/title';

const OrderEditPage = () => {
  const [orderData, setOrderData] = useState({});
  const { setIsLoading } = useContext(GlobalContext);
  const { t } = useTranslation(['backoffice']);
  const { id } = useParams();
  const navigate = useNavigate();
  const { isNewShippingAddress, isGiftOrder, giftData } =
    useCartStore();
  const { setTitle } = useOutletContext();

  useEffect(() => {
    const loadDetailOrder = async (id) => {
      const response = await getDetailOrderProfile(id);
      if (response?.status === 200) {
        setOrderData(response?.data);
      }
    };

    if (id) {
      setIsLoading(true);
      loadDetailOrder(id);
      setIsLoading(false);
    }
  }, [id]);

  useEffect(() => {
    if (orderData) {
      setTitle(t('edit', { title: orderData?.user?.full_name }));
    }
    return () => {
      setTitle('');
    };
  }, [orderData, setTitle]);

  const onSubmit = async (data) => {
    const sendValues = {
      biblioteca: data.biblioteca?.id || '',
      user: data.usuario.id,
      comentario: data.comentario,
      descuento: parseInt(data.descuento),
      order_status: data.order_status,
      payment_method: parseInt(data.payment_method),
      payment_status: data.payment_status,
      reembolso: data.reembolso,
      is_new_shipping_address: isNewShippingAddress,
      shipping_cost: parseFloat(orderData?.shipping_cost),
      finish_process: true,
      is_gift: isGiftOrder,
      billing_address: orderData?.billing_address || {},
      shipping_address: orderData?.shipping_address || {},
      // benefited_company: data.benefited_company?.id,
      applied_coupon: orderData?.applied_coupon?.id || null,
      iva_order: getIvaOrder(data.items, data.descuento),
      total_order: getTotalOrder(data.items, data.descuento, parseFloat(orderData?.shipping_cost)),
      subtotal_order: getSubTotalOrder(data?.items, data?.descuento),
      transport_company: data.transport_company || null,
      tracking_id: data.tracking_id || '',
      items: data?.items?.map((item) => {
        return {
          id: item?.product?.id,
          quantity: parseInt(item?.quantity),
          total_price: parseFloat(item?.total_price),
          state: parseInt(item?.state),
          discount: parseInt(item?.discount),
        };
      }),
    };
    if (isGiftOrder === true) {
      sendValues.gift_data = giftData;
    }
    try {
      const { status } = await editDetailOrder(sendValues, id);
      if (status === 200 || status === 201) {
        toast.success(t('editadocorrectamente'));
        navigate('/intranet/purchases', { replace: true });
      } else toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
    } catch (error) {
      console.error('Error en onEdit:', error);
    }
  };

  return (
    <>
      <Title
        text={
          <span>
            {t('orderEdit')} <span className="span-info">{`(#${orderData?.code})`}</span>
          </span>
        }
      />
      <OrderForm onSubmit={onSubmit} data={orderData} isEditing={true} />
    </>
  );
};

export default OrderEditPage;